RivalIQ.module('overrides.jquery', function (apps, App, Backbone, Marionette, $, _, window) {

    'use strict';

    // cache the original $.ajax method, and export it for friends
    window.$ajax = $.ajax;

    // the maximum number of retries per request (for timeout only)
    const MAXIMUM_TIMEOUT_RETRIES = 3;
    // the amount of time in ms to factor into wait time between timeout retries
    const TIMEOUT_DELAY_FACTOR = 1000;
    // the timeout HTTP status code (magic number)
    const TIMEOUT_STATUS_CODE = 503;

    // Note: this list of ignored methods matches the defaults in middleware/csrf.js
    const IGNORED_CSRF_METHODS = ['GET', 'HEAD', 'OPTIONS'];

    /**
     * A function that returns the default $.ajax method.
     * @returns {jQuery.ajax|*|Window.$ajax}
     */
    function $ajax() {

        return window.$ajax;
    }

    // let the craziness begin, for timeouts
    $.ajax = function (url, options) {

        let opts = options || {};
        const deferred = $.Deferred();

        // if we got one argument, check usage to determine options
        if (arguments.length === 1) {

            opts = (typeof url === 'string') ? {
                url: url
            } : url;
        }

        if (RivalIQ.state.versioning) {
            const versionHeaders = RivalIQ.state.versioning.getXhrHeaders();
            // NOTE the version headers should not be overridden
            opts.headers = _.defaults(versionHeaders, opts.headers);
        }

        // Only set the csrf-token HTTP request header on state-changing requests.
        const httpMethod = _.get(opts, ['type'], 'GET').toUpperCase();

        if (IGNORED_CSRF_METHODS.indexOf(httpMethod) < 0) {
            opts.headers = opts.headers || {};
            opts.headers['csrf-token'] = RivalIQ.state.product.get('csrfToken');
        }

        opts.xhrFields = opts.xhrFields || {};
        opts.xhrFields.withCredentials = true;

        // this is a shorthand function for convenience, as we will
        // retry on timeouts
        const request = function () {

            const xhr = $ajax()(opts);
            // let's take what we want from xhr and stuff it on our deferred
            deferred.abort = _.bind(xhr.abort, xhr);
            return xhr;
        };

        // let's make an anchor tag for its location properties
        const a = document.createElement('a');
        a.href = opts.url;

        // if this is not a request to something we control, then just use the default behavior
        // NOTE: this is something of a dangerous game, as eventually we could use CORS
        // to make cross domain requests to servers/services in our own control, that are not
        // part of the web server
        if (a.host !== window.location.host) {

            return request();
        }

        // cache configured handlers, if they exist
        const cachedError = opts.error;
        const cachedSuccess = opts.success;
        const cachedComplete = opts.complete;

        // remove these handlers, as we will overwrite them below
        delete opts.error;
        delete opts.success;
        delete opts.complete;

        // the current attempt (in case of timeout)
        let attempts = 0;

        // here is our error handler...
        opts.error = function (xhr, status, e) {

            // check to see if this is a timeout based on status code, and we can still retry
            const maxTimeoutRetries = (_.isNumber(opts.maxTimeoutRetries) && opts.maxTimeoutRetries > -1 ?
                opts.maxTimeoutRetries : MAXIMUM_TIMEOUT_RETRIES);

            if (xhr.status === TIMEOUT_STATUS_CODE && (attempts++ < maxTimeoutRetries)) {

                const delay = Math.round((Math.pow(2, attempts - 1) + Math.random()) * $.ajax.TIMEOUT_DELAY_FACTOR);
                return _.delay(request, delay);
            }

            // Set api error if present
            if (xhr.responseJSON && xhr.responseJSON.RESTerror) {
                xhr.errorObj = xhr.responseJSON.RESTerror;
                xhr.errorName = xhr.errorObj.name;
                xhr.errorMessage = xhr.errorObj.message;
                xhr.errorData = xhr.responseJSON.data;
            }

            if (xhr.errorName === 'MetadataVersionMismatchError') {
                RivalIQ.execute('metadataMismatchReceived');
                return;
            }

            if (xhr.errorName === 'CsrfTokenMismatchError') {
                RivalIQ.execute('csrfTokenMismatchReceived');
                return;
            }

            if (xhr.errorName === 'AuthenticationError') {
                const redirectPath = xhr.responseJSON.data.redirect;
                if (redirectPath !== window.location.pathname) {
                    const redirect = [
                        redirectPath,
                        '?originalDest=',
                        encodeURIComponent(window.location.pathname + window.location.search)
                    ].join('');

                    window.location = redirect;
                    return;
                }
            }


            // if cached error is a handler, then let's call it
            if (typeof cachedError === 'function') {

                cachedError(xhr, status, e);
            }

            // reject the promise
            deferred.reject(xhr, status, e);
        };

        // here is our success handler, it mostly gets out of the way...
        opts.success = function (data, status, xhr) {

            // if there is a cached success handler, then let's call it
            if (typeof cachedSuccess === 'function') {

                cachedSuccess(data, status, xhr);
            }

            // resolve the promise
            deferred.resolve(data, status, xhr);
        };

        // here is our completion handler...
        opts.complete = function (xhr, status) {

            // if we can still retry, don't alert the horde quite yet
            // NOTE: because of the order in which handlers fire, we test <= rather than <,
            // as the error handler will have executed before the completion handler
            if (xhr.status === TIMEOUT_STATUS_CODE && (attempts <= MAXIMUM_TIMEOUT_RETRIES)) {

                return;
            }

            // if there is a cached complete handler, then let's call it
            if (typeof cachedComplete === 'function') {

                cachedComplete(xhr, status);
            }
        };

        // make the request
        request();

        // return our promise
        return deferred;
    };

    // expose this, mostly for testing
    $.ajax.TIMEOUT_DELAY_FACTOR = TIMEOUT_DELAY_FACTOR;

}, window);
